import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/index.jsx';

export default function makeStore(preloadedState = {}){ // prevent name collision with createStore
    return createStore( 
        rootReducer,
        preloadedState,
        applyMiddleware(thunk)
    );
}



// WEBPACK FOOTER //
// ./src/store/make.jsx